import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import { MdCheckCircle, MdError, MdLink } from "react-icons/md";

import {
  Box,
  makeStyles,
  colors,
  Table,
  TableRow,
  TableCell,
  Avatar,
  Icon,
  TableBody,
  Typography
} from '@material-ui/core';

import DescriptionIcon from '@material-ui/icons/Description';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2),
    backgroundColor: colors.common.white
  }
}));

const MODE_FULL = 0;
const MODE_COMPACT = 1;
const LEVEL_ACCESS_HIDE = -1;
const LEVEL_ACCESS_DISABLED = 0;
const LEVEL_ACCESS_ENABLED = 1;

const getName = (name) => {
  var value = "";
  const tokens = name.split(" ");
  if (tokens.length == 1) {
    let word = tokens[0];
    value = word.substring(0, 8) + "...";
  } else {
    value = name;
  }
  return value;
  //  return (name.length > 5 ) ? 'MMMMM mmmm' : name
}

const FileList = ({ files, selectedMode }) => (

  <Table size="small" aria-label="files">
    <TableBody>
      {files.map(item => (
        <TableRow hover key={item.id} >

          <TableCell>

            {(screen.width <= 480 || selectedMode == MODE_COMPACT) ?
              (
                <Box>
                  <Avatar className={useStyles().avatar} >
                    {<Icon component={DescriptionIcon} style={{ color: colors.blue[300] }} ></Icon>}
                  </Avatar>
                  {(screen.width <= 480 || selectedMode == MODE_COMPACT) ? getName(item.name) : item.name}
                </Box>

              )
              :
              (
                <Box display="flex" alignItems="center">
                  <Avatar className={useStyles().avatar} >
                    {<Icon component={DescriptionIcon} style={{ color: colors.blue[300] }} ></Icon>}
                  </Avatar>
                  {(screen.width <= 480 || selectedMode == MODE_COMPACT) ? getName(item.name) : item.name}
                </Box>
              )}

          </TableCell>

          {(screen.width <= 480 || selectedMode == MODE_COMPACT) ? "" :
            (<TableCell>
              {item.readableSize}
            </TableCell>)}


          {(screen.width <= 480 || selectedMode == MODE_COMPACT) ? "" :
            (<TableCell style={(item.error) ? { color: 'red' } : {}} >
              {(item.error) ? ("Erro de Envio") : item.progress + "%"}
            </TableCell>
            )}


          <TableCell>
            <Box>

              <CircularProgressbar
                styles={{
                  root: { width: 34 },
                  path: { stroke: colors.indigo[500] }
                }}
                strokeWidth={22}
                value={item.progress}
              />

            </Box>

          </TableCell>

          <TableCell>
            <Box>
              {item.uploaded && <MdCheckCircle size={24} color="#78e5d5" />}
              {item.error && <MdError size={24} color="#e57878" />}
            </Box>

          </TableCell>

        </TableRow>
      ))
      }

    </TableBody>
  </Table>
);

export default FileList;